import styled from 'styled-components';
import { Image } from '@/shared/ui/image/Image';
import { Button } from '@/shared/ui/form/button/button';

const StyledPromoButton = styled(Button)`
  display: ${({ $isView }) => $isView ? 'flex' : 'none'};
  height: 40px;
  padding: 0 24px 0 12px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  max-width: 242px;
`;

const StyledIcon = styled(Image)`
  width: 28px;
  height: 28px;
  
  img {
    width: 100%;
    height: 100%;
  }
`;

export { StyledPromoButton, StyledIcon };